import React, { useCallback, useState } from 'react'
import { PageContext } from 'contexts'

export default function PageProvider({ children }) {
  const [pageProps, setPageProps] = useState(null)

  const mergePageProps = useCallback(
    (values) => {
      setPageProps((previous) => ({ ...previous, ...values }))
    },
    [setPageProps],
  )

  return (
    <PageContext.Provider
      value={{
        pageProps,
        setPageProps: mergePageProps,
        // deprecated
        header: pageProps,
        setHeader: mergePageProps,
      }}
    >
      {children}
    </PageContext.Provider>
  )
}
